import { BrowserModule } from '@angular/platform-browser';
import { Injector, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';

import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateModule, TranslateLoader, TranslatePipe } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


import { AppComponent } from './app.component';
import { NavbarComponent } from './shared/navbar/navbar.component';
import { SidebarComponent } from './shared/sidebar/sidebar.component';
import { SettingsPanelComponent } from './shared/settings-panel/settings-panel.component';
import { FooterComponent } from './shared/footer/footer.component';
import { DashboardComponent } from './dashboard/dashboard.component';
// import { CarouselComponent } from './carousel/carousel.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
// import { TodoComponent } from './apps/todo-list/todo/todo.component';
import { SpinnerComponent } from './shared/spinner/spinner.component';
import { ContentAnimateDirective } from './shared/directives/content-animate.directive';
import { TodoListComponent } from './apps/todo-list/todo-list.component';

import { NgCircleProgressModule } from 'ng-circle-progress';
// import { LightboxModule } from 'ngx-lightbox';

import { CarouselModule } from 'ngx-owl-carousel-o';


import { BarRatingModule } from "ngx-bar-rating";
import { environment } from 'src/environments/environment';

export function HttpLoaderFactory(http: HttpClient) {
  console.log("app.modules", './assets/i18n/', '.json?version=' + environment.Version)
  return new TranslateHttpLoader(http, './assets/i18n/', '.json?version=' + environment.Version);
}

import { LoaderComponent } from './shared/components/controls/loader/loader.component';
import { LoaderService } from './service/loader.service';
import { LoaderInterceptor } from './service/loader.interceptor';
import { HttpConfigInterceptor } from './service/core/httpconfig.interceptor';
import { AppInjector } from './service/core/app-injector.service';
import { SharedModule } from './shared/shared.module';

import { ChartsModule } from 'ng2-charts';
import { MorrisJsModule } from 'angular-morris-js';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { AngularFireModule } from '@angular/fire/compat';
import { MessagingService } from './shared/messaging.service';

import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { SubmitedOrderCurrentYearComponent } from 'src/app/charts/submited-order-current-year/submited-order-current-year.component';
import { ImplantationOrderYearlyComponent } from 'src/app/charts/implantation-order-yearly/implantation-order-yearly.component';
import { IncomePerMonthYearlyComponent } from 'src/app/charts/income-per-month-yearly/income-per-month-yearly.component';
import { ServiceTypeCurrentYearComponent } from 'src/app/charts/service-type-current-year/service-type-current-year.component';
//import { SubmittedOrderPopupComponent } from './chart-popup/submitted-order-popup/submitted-order-popup.component';
//import { ImplantationOrderPopupComponent} from './chart-popup/implantation-order-popup/implantation-order-popup.component'
import { RecaptchaV3Module, RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import { WorkingStationLiveComponent } from './working-station-live/working-station-live.component';
// import { ChartistComponent  } from 'src/app/charts/chartist/chartist.component';
import { DataTablesModule } from 'angular-datatables';
import { CategoryComponent } from './charts/category/category.component';
import { DelayOrderComponent } from './delay-order/delay-order.component';
import { RDCPrimaryDataComponent } from './rdc/rdcprimary-data/rdcprimary-data.component';
// import { NewCustomersRegistrationComponent } from './reports-analytics/new-customer-registration/new-customer-registration.component';
// import { TopActiveCustomerComponent } from './reports-analytics/top-active-customer/top-active-customer.component';
@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    SidebarComponent,
    SettingsPanelComponent,
    FooterComponent,
    DashboardComponent,
    TodoListComponent,
    // TodoComponent,
    SpinnerComponent,
    ContentAnimateDirective,
    LoaderComponent,
    // CarouselComponent
    SubmitedOrderCurrentYearComponent,
    ImplantationOrderYearlyComponent,
    IncomePerMonthYearlyComponent,
    ServiceTypeCurrentYearComponent,
    WorkingStationLiveComponent,
    CategoryComponent,
    DelayOrderComponent,
    RDCPrimaryDataComponent
    //NewCustomersRegistrationComponent,
    //TopActiveCustomerComponent,
    //SubmittedOrderPopupComponent,
    //ImplantationOrderPopupComponent
    // ChartistComponent
  ],
  imports: [
    BrowserModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireMessagingModule,
    AppRoutingModule,
    HttpClientModule,
    NgbModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    DataTablesModule,
    ToastrModule.forRoot({
      closeButton: true,
      progressBar: true,
      tapToDismiss: true,
      progressAnimation: 'increasing',
      timeOut: 8000,
      extendedTimeOut: 5000,
      disableTimeOut: false,
      easeTime: 300,
      positionClass: 'toast-top-right',


    }),
    ChartsModule,
    MorrisJsModule,
    // LightboxModule,
    CarouselModule,
    BarRatingModule,
    NgCircleProgressModule.forRoot({
      // set defaults here
      "radius": 60,
      "space": -10,
      outerStrokeWidth: 16,
      innerStrokeWidth: 8,
      animationDuration: 300,
      "showImage": true,
      "responsive": true,
      "showInnerStroke": true,
      "imageHeight": 105,
      "imageWidth": 105,
      "showTitle": false,
      "showSubtitle": false
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    SharedModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    RecaptchaV3Module
  ],
  exports: [NgMultiSelectDropDownModule],
  providers: [LoaderService, TranslatePipe, MessagingService,
    { provide: HTTP_INTERCEPTORS, useClass: HttpConfigInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptcha.siteKey, },
  ],

  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(injector: Injector) {
    AppInjector.setInjector(injector);
  }
}
